import { render } from "./BulkOrderAssign.vue?vue&type=template&id=15dd73e1&scoped=true"
import script from "./BulkOrderAssign.vue?vue&type=script&lang=js"
export * from "./BulkOrderAssign.vue?vue&type=script&lang=js"

import "./BulkOrderAssign.vue?vue&type=style&index=0&id=15dd73e1&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dd73e1"]])

export default __exports__